import React from "react"
import classNames from "classnames";
import styles from "./Layout.module.scss";

const Content = ({ className, style, children}) => {
    return <div className={classNames(styles.page, className)} style={style}>
        {children}
    </div>
};

export default Content;